exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/home/home.component.css
// module id = ../../../../../src/app/pages/home/home.component.css
// module chunks = main